import React from 'react';
import { Box, Typography } from '@mui/material';

export const DrawerVideo = ({ videoUrl, thumbnailUrl }) => {
  return (
    <Box sx={{ marginBottom: '8px' }}>
      <Box sx={{ width: '100%', borderRadius: '4px', overflow: 'hidden' }}>
        <Box
          sx={{
            width: '100%',
            height: '200px',
            backgroundColor: '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          {videoUrl && (
            <video 
              src={videoUrl || thumbnailUrl} 
              controls 
              style={{ width: '400px', height: '200px' }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
